<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Leave Application Approval</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/absenceleave">Leave & Absences Record</router-link>
             </li>
             <li class="breadcrumb-item active">Leave Application Approval</li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
       <div class="report-container">
          <img class="logo-print" width="190" height="110" src="/static/img/blueprintlogo.png" alt="..."/><br/><br/>
          <div class="report-border-full">
             <div class="report-header">
                LEAVE APPLICATION FORM
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-6">
                   <p class="margin-p"><b>Employee Name:</b> {{item.full_name}}</p>
                   <p class="margin-p"><b>Department:</b> {{item.department_name | capitalize}}</p>
                </div>
                <div class="col-md-6">
                   <p class="margin-p"><b>Employee Number:</b> {{item.emp_id}}</p>
                   <p class="margin-p"><b>Position:</b> {{item.position_name | capitalize}}</p>
                </div>
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-12">
                   <p class="margin-p"><b>Date Filled :</b> {{item.date_filled}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Type of Leave :</b> {{item.leave_type}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Total Days:</b> {{item.no_of_days}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>Start Date :</b> {{item.start_date}}</p>
                </div>
                <div class="col-md-12">
                   <p class="margin-p"><b>End Date :</b> {{item.end_date}}</p>
                </div>
             </div>
          </div>
          <div class="report-gatter"></div>
          <div class="col-md-12 report-border-full">
             <div class="row">
                <div class="col-md-12">
                   <p class="margin-p"><b>Reason for Leave / Absent :</b><br/> {{item.reason}}</p>
                </div>
             </div>
          </div>
          <form @submit="update_leave">
             <div v-if="item.roles === 1  && item.belongs_to != 0">
                <b>Departmental Approval</b>
                <div class="report-gatter"></div>
                <div class="col-md-12 report-border-full">
                   <!-- TL --> 
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Supervisor Name:</b></p>
                         <input type="text" class="form-control" v-model="item.supervisor" readonly>   
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Supervisor Approval:</b></p>
                         <input type="text" class="form-control" v-model="item.tl_status" readonly>
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         <input type="text" class="form-control" v-model="item.tl_date_approved" readonly>
                      </div>
                   </div>
                   <!-- END -->  
                   <!-- ASM -->
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head's Name:</b></p>
                         <input type="text" class="form-control" v-model="item.department_head" readonly>
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head Approval:</b></p>
                         <input type="text" class="form-control" v-model="item.asm_status" readonly>
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         <input type="text" class="form-control" v-model="item.asm_date_approved" readonly>
                      </div>
                   </div>
                   <!-- END -->   
                </div>
             </div>
             <div v-if="item.roles === 2">
                <b>Departmental Approval</b>
                <div class="report-gatter"></div>
                <div class="col-md-12 report-border-full">
                   <!-- ASM -->
                   <div class="row">
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head's Name:</b></p>
                         <input type="text" class="form-control" v-model="item.department_head" readonly>
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Departmental Head Approval:</b></p>
                         <input type="text" class="form-control" v-model="item.asm_status" readonly>
                      </div>
                      <div class="col-md-4">
                         <p class="margin-p"><b>Date Approved:</b></p>
                         <input type="text" class="form-control" v-model="item.asm_date_approved" readonly>
                      </div>
                   </div>
                   <!-- END -->   
                </div>
             </div>
             <b>HR Department Approval</b>
             <div class="report-gatter"></div>
             <div class="col-md-12 report-border-full">
                <div class="row">
                   <div class="col-md-4">
                      <p class="margin-p"><b>Remarks:</b></p>
                      <select class="form-control" v-model="item.remarks" disabled>
                         <option disabled value="">-- Please select one --</option>
                         <option value="With Pay">With Pay</option>
                         <option value="Without Pay">Without Pay</option>
                      </select>
                   </div>
                   <!-- <slot v-if="item.status == 'pending'">   -->
                   <div class="col-md-4">
                      <p class="margin-p"><b>HR Approval:</b></p>
                      <select class="form-control" v-model="item.status" required @change="reasonShow">
                         <option disabled value="">-- Please select one --</option>
                         <option value="approved">Approve Request</option>
                         <option value="rejected">Decline Request</option>
                      </select>
                   </div>
                </div>
             </div>
            <div v-if="reason == true"> 
             <div class="report-gatter"></div>
              <div class="col-md-12  report-border-full">
                  <p class="margin-p"><b>Reason:</b></p><small><i>Please write a reason why you decline his/her leave request.</i></small>
                <textarea  cols="100" rows="10" v-model="reason_to_declined" class="form-control reason"></textarea>
              </div>  
             </div>  
             <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6">
                   <div class="form-group">
                      <!-- <slot v-if="item.status == 'pending'"> -->
                      <div class="float-right">  
                         <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button> 
                      </div>
                      <!-- </slot>  -->
                   </div>
                </div>
             </div>
          </form>
       </div>
       <br/>
       <br/>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'  
export default {
    components: {
      Card
   },
   data() {
      return {
         item: {},
         reason:false,
         reason_to_declined:''
      }
   },
   mounted: function() {
      this.getItem()
   },
   methods: {
    reasonShow(){
        if(this.item.status == 'rejected'){
            this.reason = true
        }
        else{
          this.reason = false
        }
    },
    
      getItem() {
        axios.get('api/leaveabsences/get/' + this.$route.params.id)  
             .then(response => { this.item = response.data; })
             .catch(error => {  console.log(error) });
      },

      update_leave(e) {
         e.preventDefault();
         axios.post('api/leaveabsences/update/hr/' + this.item.id, {
               date_filled: this.item.date_filled,
               no_of_days: this.item.no_of_days,
               leave_type: this.item.leave_type,
               remarks: this.item.remarks,
               start_date: this.item.start_date,
               end_date: this.item.end_date,
               reason: this.item.reason,
               status: this.item.status,
               reason_to_declined:this.reason_to_declined
            })
            .then(resp => {
                if(resp.data.response == 'rejected'){
                      this.$swal('Rejected', resp.data.message , 'success')
                      this.$router.push({name: 'absence-leave'})
                }else if(resp.data.response == 'approved'){
                      this.$swal('Approved', resp.data.message , 'success')
                      this.$router.push({name: 'absence-leave'})
                }else if(resp.data.response == 'error'){
                      this.$swal('error', resp.data.message , 'error')
                }
                console.log(resp)
            })
            .catch(e => {
               console.log(e.response)
            })
      }
   },

}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/todo-leave-approval.vue